import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout';
import CountryList from './CountryList';
import Breadcrumb from '../components/Breadcrumb';

export default function CountryPage() {
    return (
        <>
            {/* MasterLayout */}
            {/* <MasterLayout> */}
                <Breadcrumb title="Country" />
                <CountryList />
            {/* </MasterLayout> */}
        </>
    );
}
